var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "briefcase"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60019 9.59995V7.99995C9.60019 6.72691 10.1059 5.50601 11.0061 4.60584C11.9063 3.70566 13.1272 3.19995 14.4002 3.19995H17.6002C18.8732 3.19995 20.0941 3.70566 20.9943 4.60584C21.8945 5.50601 22.4002 6.72691 22.4002 7.99995V9.59995H25.6002C26.4489 9.59995 27.2628 9.93709 27.8629 10.5372C28.4631 11.1373 28.8002 11.9513 28.8002 12.8V18.5119C24.7036 20.0299 20.369 20.8047 16.0002 20.7999C11.6314 20.8048 7.29678 20.03 3.2002 18.5119V12.8C3.2002 11.9513 3.53734 11.1373 4.13745 10.5372C4.73757 9.93709 5.5515 9.59995 6.4002 9.59995H9.60019ZM12.8002 7.99995C12.8002 7.5756 12.9688 7.16864 13.2688 6.86858C13.5689 6.56852 13.9758 6.39995 14.4002 6.39995H17.6002C18.0245 6.39995 18.4315 6.56852 18.7316 6.86858C19.0316 7.16864 19.2002 7.5756 19.2002 7.99995V9.59995H12.8002V7.99995ZM14.4002 16C14.4002 15.5756 14.5688 15.1686 14.8688 14.8686C15.1689 14.5685 15.5758 14.4 16.0002 14.4H16.0162C16.4405 14.4 16.8475 14.5685 17.1476 14.8686C17.4476 15.1686 17.6162 15.5756 17.6162 16C17.6162 16.4243 17.4476 16.8313 17.1476 17.1313C16.8475 17.4314 16.4405 17.6 16.0162 17.6H16.0002C15.5758 17.6 15.1689 17.4314 14.8688 17.1313C14.5688 16.8313 14.4002 16.4243 14.4002 16Z",
    fill: "#8F03ED"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.2002 21.9072V25.6C3.2002 26.4487 3.53734 27.2627 4.13745 27.8628C4.73757 28.4629 5.5515 28.8 6.4002 28.8H25.6002C26.4489 28.8 27.2628 28.4629 27.8629 27.8628C28.4631 27.2627 28.8002 26.4487 28.8002 25.6V21.9072C24.676 23.2972 20.3524 24.0042 16.0002 24C11.5266 24 7.22099 23.264 3.2002 21.9072Z",
    fill: "#A412FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.c467b75ee1699062d927ef50163a6a65.svg";
export { ForwardRef as ReactComponent };